import React from 'react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto object-contain"
            />
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-right">
            <a
              href="https://www.google.com/maps?q=240+Main+Street,+Danbury,+CT"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-[#D4AF37] text-sm mb-2 block transition-colors"
            >
              {companyInfo.address}
            </a>
            <div className="flex items-center justify-center md:justify-end gap-4 text-sm">
              <a
                href={companyInfo.telLink1}
                className="text-[#D4AF37] hover:text-[#E8C554] transition-colors"
              >
                {companyInfo.phone1}
              </a>
              <span className="text-white/30">|</span>
              <a
                href={companyInfo.telLink2}
                className="text-[#D4AF37] hover:text-[#E8C554] transition-colors"
              >
                {companyInfo.phone2}
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="gold-divider mt-8" />
        <p className="text-center text-white/40 text-xs mt-8">
          © {currentYear} {companyInfo.name}. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
